import apiClient from '../utils/apiClient';

const tagEndpoint = '/tag';

// Get all tags (normal format)
export const GetAllTagsNormal = async () => {
  try {
    const response = await apiClient.get(`${tagEndpoint}/tagList`);
    return response.data;
  } catch (error) {
    console.error('Error fetching tags:', error);
    throw error;
  }
};

// Get all tags with detailed format
export const GetAllTags = async () => {
  try {
    const response = await apiClient.get(`${tagEndpoint}/tagList`);
    const responseData = response.data;

    const formattedData = responseData.flatMap(item =>
      item.device.map(device => ({
        id: device.uuid,
        deviceName: device.name,
        connectionType: device.connectionType,
        tags: device.tag.map(tag => ({
          registerId: tag.id,
          name: tag.name,
          type: tag.type,
          address: tag.address,
          value: tag.value,
          unit: tag.unit,
          isModify: tag.Modify ? tag.Modify.status : 'NA',
          modifyValue: tag.modify?.value ?? 'n.a.',
          modifyStatusInfo: tag.Modify ? tag.Modify.status_info : null,
          functionId: tag.modbusFunctionId,
          homePage: tag.homePage,
          function: tag.function,
          deviceId: device.uuid,
          deviceName: device.name,
        })),
      }))
    );
    return formattedData;
  } catch (error) {
    console.error('Error formatting tags:', error);
    throw error;
  }
};

// Create a tag
export const createTag = async tag => {
  const endpoint =
    tag.function === 'VirtualTag' ? `${tagEndpoint}/Virtual` : `${tagEndpoint}`;

  try {
    const response = await apiClient.post(endpoint, tag);
    return response.data;
  } catch (error) {
    console.error('Error creating tag:', error);
    throw error;
  }
};

// Update a tag
export const put = async (id, tag) => {
  const endpoint =
    tag.function === 'VirtualTag'
      ? `${tagEndpoint}/Virtual?id=${id}`
      : `${tagEndpoint}?id=${id}`;

  try {
    const response = await apiClient.put(endpoint, tag);
    return response.data;
  } catch (error) {
    console.error('Error updating tag:', error);
    throw error;
  }
};

// Delete a tag
export const deleteTag = async id => {
  try {
    const response = await apiClient.delete(`${tagEndpoint}?id=${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting tag:', error);
    throw error;
  }
};

export const removeWritable = async id => {
  try {
    const response = await apiClient.put(
      `${tagEndpoint}/RemoveWritable?id=${id}`
    );
    return response.data;
  } catch (error) {
    console.error('Error disabling tag:', error);
    throw error;
  }
};

// Update tag with another tag
export const updateTagWithTag = async (id, tagId) => {
  try {
    const response = await apiClient.put(
      `${tagEndpoint}/FromTag?id=${id}&tag=${tagId}`
    );
    return response.data;
  } catch (error) {
    console.error('Error updating tag with another tag:', error);
    throw error;
  }
};

// Update tag with value
export const updateTagWithValue = async (id, value) => {
  try {
    const response = await apiClient.put(
      `${tagEndpoint}/FromEntry?id=${id}&value=${value}`
    );
    return response.data;
  } catch (error) {
    console.error('Error updating tag with value:', error);
    throw error;
  }
};

// Export tags to Excel
export const exportTagsToExcel = async () => {
  try {
    const response = await apiClient.get(`${tagEndpoint}/exportExcel`, {
      responseType: 'blob',
    });
    return response.data;
  } catch (error) {
    console.error('Error exporting tags to Excel:', error);
    throw error;
  }
};
